<app-dea-widget-wrapper>
  <div class="row m-0 p-0">
    <div class="col m-0 p-0">
      <!-- <app-dea-search-bar (text)="onText($event)"></app-dea-search-bar> -->
    </div>
    <div class="col-auto m-0 p-0 ms-2">
      <button mat-flat-button color="primary" class="fw-bold px-3 py-1 rounded-pill" (click)="showLicenseDialog()">
        Aggiungi Licenza
      </button>
    </div>
  </div>
  <div class="v-spacer"></div>
  <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="height: 96px;">
    <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
  </div>
  <div *ngIf="!loading && error" class="d-flex justify-content-center align-items-center" style="height: 96px;">
    {{error.message}}
  </div>
  <div *ngIf="!loading && !error" class="m-0 p-0">
    <div *ngFor="let license of licenses;" class="mb-3">
      <div class="mb-3 border dea-radius p-3">
        <div class="d-flex flex-row gap-3">
          <div class="pt-2">
            <img src="{{license.favicon}}" alt="{{license.title}}" height="32" width="32" />
          </div>
          <div class="d-flex flex-column gap-2 flex-grow-1 pt-2">
            <div class="fw-bold" style="font-size: 1.3rem;">{{license.title}}</div>
            <div *ngIf="license.private_key || license.key" class="d-flex flex-column gap-1">
              <div *ngIf="license.private_key" class="col m-0 p-0">Chiave Privata: {{license.private_key}}</div>
              <div *ngIf="license.key" class="col m-0 p-0">Chiave Condivisa: {{license.key}}</div>
            </div>
            <div class="d-flex flex-row gap-3">
              <div class="col m-0 p-0">Inizio: {{license.start ? (license.start | date:'yyyy-MM-dd') : ' -'}}</div>
              <div class="col m-0 p-0">Fine: {{license.end ? (license.end | date:'yyyy-MM-dd') : ' -'}}</div>
            </div>
          </div>
          <div class="d-flex flex-column justify-content-between">
            <div class="d-flex flex-row justify-content-end gap-2">
              <a href="{{license.dashboard_link}}" target="_blank" referrerpolicy="no-referrer">
                <button *ngIf="license.dashboard_link" class="d-flex align-items-center dea-icon-btn dea-pointer"
                  mat-icon-button title="Apri Dashboard: {{license.dashboard_link}}" color="secondary">
                  <i class="bi bi-link-45deg"></i>
                </button>
              </a>
              <button class="d-flex align-items-center dea-icon-btn" mat-icon-button aria-label="Modifica Licenza"
                title="Modifica" (click)="showLicenseDialog(license.id)">
                <mat-icon>edit</mat-icon>
              </button>
              <button *ngIf="license.activeAssignmentsCount != undefined && license.activeAssignmentsCount === 0"
                class="d-flex align-items-center dea-icon-btn" mat-icon-button aria-label="Elimina Licenza"
                title="Elimina Licenza" (click)="showDeleteDialog(license.id)">
                <i class="bi bi-trash3 dea-icon-btn text-danger" style="opacity: 1;" title="Elimina Licenza"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="d-flex flex-row align-items-center justify-content-end gap-3">
          <button class="d-flex align-items-center dea-icon-btn" mat-icon-button
            aria-label="Sync assegnazioni automatiche" title="Sync assegnazioni automatiche"
            (click)="forceSync(license.id)">
            <mat-icon>refresh</mat-icon>
          </button>
          <app-dea-chip-status title="Visualizza Dettagli" [label]="'Assegnate: '+license.activeAssignmentsCount"
            [status]="true" [clickHandler]="fakeFunc" routerLink="/licenza/{{license.id}}">
          </app-dea-chip-status>
        </div>
      </div>
    </div>
  </div>
  <div class="v-spacer"></div>
  <app-listing-pagination-bar [paginationData]="pagination" (pageEmitter)="onPage($event)"></app-listing-pagination-bar>
</app-dea-widget-wrapper>